import React, { useEffect } from 'react'
import Select, { ActionMeta, GroupBase, MultiValue, OptionsOrGroups, SingleValue } from 'react-select';

type Props = {
    options?: OptionsOrGroups<unknown, GroupBase<unknown>>
    is_multi?: boolean,
    onChange?: (selected: MultiValue<unknown>) => void,
    onChangeSingle?: (selected: SingleValue<unknown>) => void,
    onInputChange?: (inputValue: string) => void;
    placeholder?: string
    defaultValue ?: OptionsOrGroups<any, any>|null|unknown
    customFontSize?: string
    minWidth?: string
    disabled?: boolean
}

const CustomSelect: React.FC<Props> = ({ options, placeholder, onChange, is_multi, onChangeSingle , defaultValue, onInputChange, customFontSize, minWidth, disabled}) => {
    const customStyles = {
        option: (provided: any, state: any) => ({
            ...provided,
            border: 'none',
            fontSize: '1.1rem',
            fontWeight: '500',
        }),
        control: (provided: any, state: any) => ({
            ...provided,
            border: '0 !important',
            boxShadow: 'none',
            backgroundColor: state.isFocused ? '#e4ecf2' : '#eef3f7',
            transition: 'color 0.2s ease, background-color 0.2s ease',
            padding: '0.25rem',
            fontSize: customFontSize ?  customFontSize : '1.1rem',
            fontWeight: '500',
            minWidth: minWidth ? minWidth : ''
        }),
        container: (provided: any, state: any) => ({
            ...provided,
            border: 'none'
        }),
    }

    const onSelectChange = (newValue: MultiValue<unknown>, actionMeta: ActionMeta<unknown>) => {
        if (onChange !== undefined) {
            onChange(newValue);
        }
    }

    const onSelectChangeSingle = (newValue: SingleValue<unknown>, actionMeta: ActionMeta<unknown>) => {
        if (onChangeSingle !== undefined) {
            onChangeSingle(newValue);
        }
    }

    const onInputValueChange = (inputValue: string) => {
        if (onInputChange !== undefined) {
          onInputChange(inputValue);
        }
    };

    return (
        <>
            {
                is_multi === true ?
                (
                    <Select placeholder={placeholder} isSearchable={true} isMulti={true} styles={customStyles} options={options} defaultValue={defaultValue} onChange={onSelectChange} onInputChange={onInputValueChange} isDisabled={disabled}></Select>
                )
                :
                (
                    <Select placeholder={placeholder} isSearchable={true} isMulti={false} styles={customStyles} options={options} defaultValue={defaultValue} onChange={onSelectChangeSingle} onInputChange={onInputValueChange} isDisabled={disabled}></Select>
                )
            }
            
        </>
    )
}

CustomSelect.defaultProps = {
    placeholder: 'Select options',

}
export default CustomSelect;